



















































import { Component, Vue } from "vue-property-decorator";
import { MessageService } from "@/shared/services/message-service";
import { estados_cita } from "@/shared/dtos/estados_cita";
import estadosCitaModule from "@/store/modules/estados_cita-module";

@Component({ name: "EstadosCitaManager" })
export default class EstadosCitaManager extends Vue {
  public loading: boolean = false;
  public saving: boolean = false;
  public dialogOpen: boolean = false;
  public isEditMode: boolean = false;
  public searchText: string = "";
  public form: estados_cita = new estados_cita();
  public headers: any[] = [
    { text: "Codigo", value: "codigo" }, { text: "Nombre", value: "nombre" }, { text: "Bloquea", value: "bloquea_agenda" },
    { text: "Final", value: "es_final" }, { text: "Orden", value: "orden_visual" }, { text: "Acciones", value: "actions", sortable: false }
  ];
  public mounted() { this.refresh(); }
  public get rows(): estados_cita[] { return estadosCitaModule.rows; }
  public get filteredRows(): estados_cita[] {
    const s = (this.searchText || "").toLowerCase().trim();
    if (!s) return this.rows;
    return this.rows.filter(x => (x.codigo + " " + x.nombre).toLowerCase().indexOf(s) !== -1);
  }
  public async refresh() { this.loading = true; try { await estadosCitaModule.getRows(); } finally { this.loading = false; } }
  public openCreate() { this.isEditMode = false; this.form = new estados_cita(); this.dialogOpen = true; }
  public openEdit(item: estados_cita) { this.isEditMode = true; this.form = new estados_cita(item); this.dialogOpen = true; }
  public async save() {
    if (!this.form.codigo || !this.form.nombre) { MessageService.alert("Validacion", "Codigo y nombre son obligatorios", MessageService.TypeWarning); return; }
    this.saving = true;
    try {
      this.form.codigo = (this.form.codigo || "").trim().toUpperCase();
      this.form.nombre = (this.form.nombre || "").trim();
      if (this.isEditMode) await estadosCitaModule.modificar(this.form); else await estadosCitaModule.guardar(this.form);
      this.dialogOpen = false; await this.refresh();
    } finally { this.saving = false; }
  }
  public remove(item: estados_cita) {
    MessageService.confirm("Quieres eliminar este estado?", "Confirmacion", async (res: boolean) => { if (!res) return; await estadosCitaModule.eliminar(item); await this.refresh(); });
  }
}
